import { EM_TAG_PLACEHOLDER as l, END_EM_TAG_PLACEHOLDER as r, PLACEHOLDER_REGEX as o } from "./help-center-articles-search19.js";
const E = (t) => /^\s*(<em>\s*<\/em>)?\s*$/.test(t) ? [] : t.trim().replace(/<em>/g, l).replace(/<\/em>/g, r).split(o).filter((e) => e !== "");
export {
  E as calculateHighlightChunks
};
//# sourceMappingURL=help-center-articles-search47.js.map
